<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    deleteTitle="Cancelamento do Faturamento de Compra"
    :formErrors="formErrors"
    ref="baseDelete"
    deleteIcon="mdi-cart-remove"
    :alwaysEnabled="true"
    deleteButtonLabel="Cancelar Faturamento"
    deleteConfirmButtonLabel="Confirmar Cancelamento do Faturamento"
  >
    <p> Você tem certeza que deseja cancelar o faturamento da compra do fornecedor <b>{{this.entry.supplier.name}}</b>, no valor de <b>{{this.entry.totalPrice  | formatCurrency }}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
  },
  methods: {
    destroyServerEntry: function(purchase) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: CANCEL_PURCHASE_BILLING_MUTATION,
            variables: {
              id: purchase.id,
            }
          })
          .then(response => {
            var errors = response.data.cancelPurchaseBilling.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const CANCEL_PURCHASE_BILLING_MUTATION = gql `
  mutation($id: ID!) {
    cancelPurchaseBilling(id: $id) {
      cashFlow {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>